import { FetchMyStoreType } from '../redux/lounges/slice';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { readLoungeAuthorizedData } from '../utils/loungeAuthRefresh';

export const getAllMyStoreApi = async ({
  sortType: _sortType,
  currentPage: _currentPage,
}: FetchMyStoreType) => {
  localStorage.setItem('pagename', 'Mousewait Store');
  return readLoungeAuthorizedData(GET_BASE_URL + '/api/v1/mystore', 'mystore');
};
